<template>
  <div>
    <Banner />
    <div class="banner">
      <p data-aos="zoom-in" data-aos-delay="1000">No siempre consigues lo que quieres, y eso es hermoso!!</p>
    </div>
    <!-- <h2 v-if="this.$store.state.loading">cargando</h2> -->
    <v-container>
      <v-row>
        <v-col class="content-post" cols="auto" xs="12" sm="12" md="8" lg="8">
           <vue-loading v-if="this.$store.state.loading" type="bubbles" color="#2F1640" :size="{ width: '100px', height: '60px' }"></vue-loading>
          <Post v-for="item in reverseBlog" data-aos="fade-up" data-aos-delay="500" :key="item._id" :post="item" />
           <div class="justify-center d-flex">
             <v-btn large class="blogsMore" to="/blogs" >Más blogs</v-btn>
           </div>
        </v-col>
        <v-col class="content-popular" cols="auto" xs="12" sm="12" md="4" lg="4">
          <SectionLateral />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import Post from '@/components/Post';
import SectionLateral from '@/components/SectionLateral';
import { VueLoading } from 'vue-loading-template'
import {mapState} from 'vuex';
export default {
  name:'home',
  components: {Banner, Post, SectionLateral,VueLoading},
  data(){
    return{
    }
  },
  created(){
    this.$store.dispatch('cargarDatos')
  },
  computed:{
    ...mapState(['blogs']),
    reverseBlog(){
      return this.$store.getters.reverseBlog
    }
  }
};
</script>
<style lang="scss" scoped>
.banner{
  position: relative;
  background: #fff;
  height: 150px;
  width: 100vw;
  align-items: center;
  display: flex;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 90%);
  & p{
    color:#8C634A;
    text-align: center;
    font-size: 3rem;
    font-family: 'Amatic SC', cursive;
    @media screen and (max-width:600px){
      font-size: 2rem;
    }
  }
}
.content-post{
  padding: 0 3.5rem;
  @media screen and (max-width:600px){
    padding:0;
  }
}
.content-popular{
  padding: 0 3.5rem;
  width: 100%;
  @media screen and (max-width:600px){
    padding: 0 ;
  }
  @media screen and (max-width:900px){ 
    margin-top:1rem;
  }
}
.blogsMore{
  background:#2F1640 !important;
  color:#fff !important;
}
</style>
